import { SuitcaseRollingIcon, BackpackIcon } from "@phosphor-icons/react";

export const baggageIcons: Record<string, React.ReactElement> = {
  CY: <BackpackIcon size={20} />,
  BG: <SuitcaseRollingIcon size={20} />,
};
